<script >import { Sphere } from "cannon-es";
import Shape from "../Shape.svelte";
export let radius;
export let offset = undefined;
export let orientation = undefined;
export let material = undefined;
const shape = new Sphere(radius);
$: {
    shape.radius = radius;
    shape.updateBoundingSphereRadius();
}
</script>

<Shape {shape} {offset} {orientation} {material}>
  <slot />
</Shape>
